import { render, staticRenderFns } from "./WalletQuickAmountButtons.vue?vue&type=template&id=72a6e400"
import script from "./WalletQuickAmountButtons.vue?vue&type=script&lang=js"
export * from "./WalletQuickAmountButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports